import type { Action } from '@ngrx/store';
import type { Project } from '../../../interfaces/Project.interface';

export enum ActionType {
    FETCH_ALL = '[PROJECTS] FETCH_ALL',
    FETCH_ALL_SUCCEEDED = '[PROJECTS] FETCH_ALL_SUCCEEDED',
    FETCH_ALL_FAILED = '[PROJECTS] FETCH_ALL_FAILED',
    SET_CURRENT_PROJECT_ID = '[PROJECTS] SET_CURRENT_PROJECT_ID',
    CREATE_PROJECT = '[PROJECTS] CREATE_PROJECT',
    SET_IS_CHANGING = '[PROJECTS] SET_IS_CHANGING',
    UPDATE_PROJECT = '[PROJECTS] UPDATE_PROJECT',
    RESET = '[PROJECTS] RESET'
}

export class FetchAll implements Action {
    readonly type = ActionType.FETCH_ALL;
}

export class FetchAllFailed implements Action {
    readonly type = ActionType.FETCH_ALL_FAILED;
}

export class FetchAllSucceeded implements Action {
    readonly type = ActionType.FETCH_ALL_SUCCEEDED;
    constructor(readonly payload: { projects: Project[]; selectedProjectId: string }) {}
}

export class SetCurrentProjectId implements Action {
    readonly type = ActionType.SET_CURRENT_PROJECT_ID;
    constructor(readonly payload: { projectId: string }) {}
}

export class CreateProject implements Action {
    readonly type = ActionType.CREATE_PROJECT;
    constructor(readonly payload: { project: Project }) {}
}

export class SetIsChanging implements Action {
    readonly type = ActionType.SET_IS_CHANGING;
    constructor(
        readonly payload: {
            isChanging: boolean;
        }
    ) {}
}

export class UpdateProject implements Action {
    readonly type = ActionType.UPDATE_PROJECT;
    constructor(
        readonly payload: {
            projectId: string;
            project: Partial<Project>;
        }
    ) {}
}

export class Reset implements Action {
    readonly type = ActionType.RESET;
}

export type Actions =
    | FetchAll
    | FetchAllSucceeded
    | FetchAllFailed
    | SetCurrentProjectId
    | CreateProject
    | SetIsChanging
    | UpdateProject
    | Reset;
